import { SlackIcon } from '../icons';
import { IconLink } from './IconLink';
import { buildSlackUserUrl } from '@appfolio/backstage-plugin-utils-common';

export const SlackUserLink = (props: { name: string; id: string }) => {
  const { name, id } = props;
  return <IconLink Icon={SlackIcon} to={buildSlackUserUrl(id)} text={name} />;
};
